export default {
  '-1': {
    type: 'danger',
    text: '失败',
  },
  0: {
    type: 'info',
    text: '执行中',
  },
  1: {
    type: 'success',
    text: '成功',
  },
};
